<div class="row">
  <div class="col-auto">
    <div class="text-primary font-weight-bold h6 mb-0 pb-0">
      <div>
        <div class="sm-card-title-2">Boda</div>
        <p *ngIf="!currency" class="text-info font-weight-bold h6 mb-0 pb-0">{{products.boda}}</p>
        <p *ngIf="currency" class="text-info font-weight-bold h6 mb-0 pb-0">{{products.boda | number}}</p>
      </div>
    </div>
  </div>
  <div class="col-auto">
    <div class="text-primary font-weight-bold h6 mb-0 pb-0">
      <div>
        <div class="sm-card-title-2">Taxi</div>
        <p *ngIf="!currency" class="text-info font-weight-bold h6 mb-0 pb-0">{{products.taxi}}</p>
        <p *ngIf="currency" class="text-info font-weight-bold h6 mb-0 pb-0">{{products.taxi | number}}</p>
      </div>
    </div>
  </div>
  <div class="col-auto">
    <div class="text-primary font-weight-bold h6 mb-0 pb-0">
      <div>
        <div class="sm-card-title-2">MicroLoan</div>
        <p *ngIf="!currency" class="text-info font-weight-bold h6 mb-0 pb-0">{{products.micro}}</p>
        <p *ngIf="currency" class="text-info font-weight-bold h6 mb-0 pb-0">{{products.micro | number}}</p>
      </div>
    </div>
  </div>
</div>